jQuery(($) => {
  if ( $('.umktg-notifications')[0] ) {
    function pushHeaderDown() {
      var notificationBarHeight = $('.umktg-notifications').outerHeight();
      $('body').css('--notification-bar-height', `${notificationBarHeight}px`);
    }

    pushHeaderDown();

    $(window).resize(function () {
      pushHeaderDown();
    });

    $(window).on('load', function () {
      pushHeaderDown();
    });

    $('.umktg-notification__close').click(function () {
      $('body').css('--notification-bar-height', '0px');
    });
  }
});